import React from 'react';
import { FormattedMessage } from 'react-intl';
import { routePathMap } from '../common/routes/routePaths';
import TIRouteProps from '../common/routes/TIRouteProps';
import SmartDiaryPage from './SmartDiaryPage';
import { SmartTimesheetIcon } from './SmartTimesheetIcon';

export const smartDiaryPageRoute: TIRouteProps = {
  path: routePathMap.smartDiary,
  component: SmartDiaryPage,
  exact: false,
  title: <FormattedMessage id="tabs.smartTimesheet" />,
  icon: <SmartTimesheetIcon />
};
